import type { AppTimezonePreference } from './timezone.constants'

import { normalizeAppTimezonePreference } from './timezone.utils'

export const APP_TIMEZONE_PREFERENCE_STORAGE_KEY = 'spark-app-timezone-preference'

function parseStoredValue(): unknown {
  try {
    const raw = globalThis.localStorage.getItem(APP_TIMEZONE_PREFERENCE_STORAGE_KEY)
    return raw ? JSON.parse(raw) : undefined
  } catch {
    return undefined
  }
}

export function readStoredAppTimezonePreference(): AppTimezonePreference {
  return normalizeAppTimezonePreference(parseStoredValue())
}

export function writeStoredAppTimezonePreference(preference: AppTimezonePreference) {
  try {
    globalThis.localStorage.setItem(
      APP_TIMEZONE_PREFERENCE_STORAGE_KEY,
      JSON.stringify(normalizeAppTimezonePreference(preference))
    )
  } catch {
    return
  }
}

export function clearStoredAppTimezonePreference() {
  try {
    globalThis.localStorage.removeItem(APP_TIMEZONE_PREFERENCE_STORAGE_KEY)
  } catch {
    return
  }
}
